import type { LunaClient } from '@vlabs/api-bindings';
import { apiContainer } from '@vlabs/api-bindings';

interface EstimateISOProps {
  file: File;
  raw?: boolean;
}

type EstimateISOReturn = Promise<Record<string, unknown> | undefined>;
export async function estimateISO({
  file,
  raw = false,
}: EstimateISOProps): EstimateISOReturn {
  if (!file) return undefined;
  const data = await (apiContainer.lunaClient as LunaClient).iso.check(file);

  if (raw) return data?.raw;

  if (data.images) return data.images?.[0];
  return data;
}
